
/** @format */

import React, { useEffect } from 'react';
import { Grid, FormControlLabel, Typography, Checkbox } from '@mui/material';
import { useStyles } from './style';
import { useFormContext } from 'react-hook-form';
import {
  InputV2,
  SelectV,
  Icons
} from 'components';
import { Controller } from 'react-hook-form';
import { USE_PERIODS } from '../../index';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';

const Constraints = ({
  usageLimitsEnabled,
  setUsageLimitsEnabled,
  usagePeriodEnabled,
  setUsagePeriodEnabled,
  periodicEnabled,
  setPeriodicEnabled,
}) => {
  // -- HOOKS --//
  const methods = useFormContext();
  const classes = useStyles();
  const { control, register, formState: { errors }, setValue } = methods;

  useEffect(() => {
    methods.register('usePeriod');
    methods.register('usePeriodCount');
    return () => {
      methods.unregister('usePeriod');
      methods.unregister('usePeriodCount');
    };
  }, [methods.register, methods.unregister]);

  return (
    <Grid container direction="row" alignItems="center" item xs={12}>
      <Grid container style={{ marginTop: 8 }} spacing={1}>
        <Grid item xs={12} md={6}>
          {/* change description to ... */}
          <InputV2
            multiline
            fullWidth
            errors={errors}
            label="محل مصرف"
            name="description"
            register={register}
            control={control}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} md={2}>
        <InputV2
          fullWidth
          errors={errors}
          rules={['isNumeric']}
          name="uniqueId"
          register={register}
          label="شناسه یکتا"
          control={control}
          englishNumber
        />
      </Grid>

      {/* Usage Amount Limits */}
      <Grid container style={{ marginTop: 16 }}>
        <Controller
          name="usageLimitsEnabled"
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <FormControlLabel
              value={value}
              control={
                <Checkbox
                  style={{ color: '#448aff' }}
                  {...rest}
                  onChange={(e) => {
                    setUsageLimitsEnabled(e.target.checked);
                    onChange(e.target.checked);
                    setValue('usePeriod', null);
                    setValue('usePeriodCount', null);
                    setUsagePeriodEnabled(false);
                  }}
                  checked={value}
                  value={value}
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxIconFill />}
                />
              }
              label="اعمال محدودیت میزان مصرف در بازه زمانی"
            />
          )}
          defaultValue={null}
        />
      </Grid>

      {usageLimitsEnabled ? (
        <>
          <Grid item xs={12} md={2}>
            <InputV2
              fullWidth
              errors={errors}
              rules={['isNumeric', 'isMin|1']}
              label="حداکثر دفعات مصرف"
              name="maxTryCount"
              register={register}
              control={control}
              englishNumber
              currency
              currencyText="مرتبه"
            />
          </Grid>

          {/* Use Period Limit */}
          <Grid container style={{ marginTop: 16 }}>
            <Controller
              name="usagePeriodEnabled"
              control={control}
              render={({ field: { onChange, value, ...rest } }) => (
                <FormControlLabel
                  value={value}
                  control={
                    <Checkbox
                      style={{ color: '#448aff' }}
                      {...rest}
                      onChange={(e) => {
                        setUsagePeriodEnabled(e.target.checked);
                        onChange(e.target.checked);
                        if (!e.target.checked) {
                          setValue('usePeriod', null);
                          setValue('usePeriodCount', null);
                        }
                      }}
                      checked={value}
                      value={value}
                      icon={<CheckBoxIcon />}
                      checkedIcon={<CheckBoxIconFill />}
                    />
                  }
                  label="اعمال بازه زمانی مصرف"
                />
              )}
              defaultValue={null}
            />
          </Grid>
          {/*  */}
          {usagePeriodEnabled ? (
            <Grid container spacing={1}>
              <Grid item xs={12} md={2}>
                <InputV2
                  fullWidth
                  errors={errors}
                  rules={['isNumeric', 'isMin|1']}
                  decimalPlaces={0}
                  minimumValue={1}
                  name="usePeriodCount"
                  register={register}
                  label="تعداد دوره"
                  control={control}
                  englishNumber
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <SelectV
                  label="نوع بازه زمانی"
                  name="usePeriod"
                  options={USE_PERIODS}
                  defaultValue=""
                  control={control}
                  register={register}
                  errors={errors}
                  fullWidth
                />
              </Grid>
            </Grid>
          ) : null}
        </>
      ) : null}

      {/* Periodic Part */}
      <Grid container style={{ marginTop: 16 }}>
        <Controller
          name="periodicEnabled"
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <FormControlLabel
              value={value}
              control={
                <Checkbox
                  style={{ color: '#448aff' }}
                  {...rest}
                  onChange={(e) => {
                    setPeriodicEnabled(e.target.checked);
                    onChange(e.target.checked);
                  }}
                  checked={value}
                  value={value}
                  icon={<CheckBoxIcon />}
                  checkedIcon={<CheckBoxIconFill />}
                />
              }
              label="اعمال تمدید خودکار دوره‌ای"
            />
          )}
          defaultValue={null}
        />
      </Grid>

      {periodicEnabled ? (
        <>
          <Grid container style={{ marginTop: 30 }}>
            <Grid item xs={12} md={6}>
              <Grid
                className={classes.dangerBox}
                container
                direction="row"
                alignItems="flex-start"
                justifyContent="flex-start"
              >
                <Grid item>
                <Icons icon="WarningTriangle" color="#E03E1A" size="28" />
                </Grid>
                <Grid item xs>
                  <Typography className={classes.dangerText}>
                    توجه کنید که این بخش بسیار حساس بوده و اگر فعال شود و به هر دلیل فراموش کنید
                    تمدید را غیرفعال نمایید هیچ اخطاری صادر نخواهد شد. بنابراین این بخش باید توسط
                    اعتبار دهنده به صورت متناوب چک و در صورت نیاز غیرفعال شود.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container style={{ marginTop: 8 }} spacing={1}>
            <Grid item xs={12} md={3}>
              <InputV2
                fullWidth
                errors={errors}
                rules={['isNumeric']}
                label="دوره تکرار"
                name="periodCount"
                register={register}
                control={control}
                englishNumber
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <SelectV
                label="بازه زمانی"
                name="periodCode"
                options={[
                  { value: 'DAY_PERIOD', label: 'روز' },
                  { value: 'MONTH_PERIOD', label: 'ماه' },
                  { value: 'YEAR_PERIOD', label: 'سال' },
                ]}
                control={control}
                errors={errors}
                fullWidth
              />
            </Grid>
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};



export default Constraints;
